import { LOCAL_STORE_JWT } from "~/utils/main";
// const jwt = localStorage.getItem(LOCAL_STORE_JWT) || false;
const base = `//www.dreamchimney.com/api`;

export const urlArtist = base + "/tracks/artist";

export const getArtist = (axios, artist) => axios.get(`${urlArtist}/find?artist=${artist}`);
export const getArtistIsFavorite = (axios, artistId) =>
  axios.post(`${urlArtist}/${artistId}/is_favorite`, { jwt: localStorage.getItem(LOCAL_STORE_JWT) || false });
export const setArtistFavorite = (axios, artistId, artistName, jwtPayload = false) =>
  axios.post(`${urlArtist}/${artistId}/favorite`, {
    jwt: jwtPayload ? jwtPayload : localStorage.getItem(LOCAL_STORE_JWT) || false,
    artistName,
  });

export const getArtistTracks = (axios, artist, page = 1) =>
  axios.get(`${urlArtist}/${encodeURIComponent(artist)}/tracks?artist=${artist}&page=${page}`);
